<template>
  <div class="ConfirmDialog">
    <van-popup v-model="showDialog">
      <div class="content">
        <div class="title">{{title}}</div>
        <div class="message" v-html="message"></div>
        <div class="btn-box flex">
          <div class="cancleBtn btn" @click="showDialog=false">{{cancelButtonText}}</div>
          <div class="confirmBtn btn" @click="confirmBtn">{{confirmButtonText}}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'
import { getItem, setItem } from '@/utils'
export default {
  props: {
    title: {
      type: String,
      default () {
        return '提示'
      }
    },
    message: {
      type: String,
      default () {
        return '提示'
      }
    },
    confirmButtonText: {
      type: String,
      default () {
        return '确认'
      }
    },
    cancelButtonText: {
      type: String,
      default () {
        return '取消'
      }
    },
    type: {
      // 1为签到弹框
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      showDialog: false
    };
  },
  computed: {
    ...mapState({
      dialog_index: 'vip_home_dialog_index'
    })
  },
  created () {},
  mounted () {},
  watch: {},
  methods: {
    ...mapMutations({
      updateDialogIndex: 'updateStateData'
    }),
    /**
     * 显示开通体验vip弹框
    */
    showPopup() {
      this.showDialog = true
    },

    /**
     * 确认弹框事件
    */
    confirmBtn() {
      this.showDialog = false
      this.$emit('confirm')
    },
    init() {
      if (this.type === 1) {
        // 签到弹框
        const date = moment().format('YYYY-MM-DD')
        const SignDate = getItem('SignDate') || null
        this.showDialog = date !== SignDate
        if (this.showDialog) {
          setItem('SignDate', date)
        }
      }
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.ConfirmDialog>:first-child {
  background-color: rgba(0,0,0,.4)
}
.ConfirmDialog>:last-child {
  border-radius: 12px;
  width: 90%;
}
.ConfirmDialog {
  .content {
    padding: 30px 30px;

    .title {
      padding: 16px 0;
      text-align: center;
      font-weight: bold;
    }
    .message {
      color: #656565;
      font-size: 26px;
      text-align: center;
      padding: 50px 0
    }
    .btn-box {
      justify-content: space-between;
      margin-top: 20px;
      .btn {
        flex: .45;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-radius: 40px;
      }
      .cancleBtn {
        color: #000000;
        background-color: #ffffff;
        border: 1px solid #E5E5E5;
      }
      .confirmBtn {
        color: #ffffff;
        background-color: #5572FD;
      }
    }
  }
}
</style>
